{
  "it": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Modifica logo (richiesto PNG)",
        "changeThemeColor": "Scegli un nuovo colore del tema"
      },
      "errors": {
        "themeColorInvalid": "Inserisci sei caratteri, 0-9 o A-F. Ad esempio 096553."
      },
      "labels": {
        "customerThemeColor": "Colore del tema cliente",
        "customerThemeColorExlainer": "Questo colore verrà utilizzato per il portale cliente. Impersonifichi un cliente per vederlo in azione.",
        "logo": "Logo"
      },
      "paused": {
        "description": "Il tuo account presso {client} esiste ancora, ma al momento il tuo accesso è disattivato, quindi la piattaforma resta chiusa. Un proprietario della tua organizzazione può riattivare il tuo accesso.",
        "noAccess": "Nessun accesso",
        "open": "Apri",
        "title": "Il tuo accesso è sospeso",
        "yourOrganizations": "Le tue organizzazioni"
      },
      "picture_logo_format": {
        "round": "Logo rotondo",
        "square": "Logo quadrato"
      }
    }
  }
}
